import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from '../../services/common/title.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'home',
    template: require('./../../templates/common/homeView.component.html'),
    providers: [TitleService, TranslationService]
})
export class HomeViewComponent {
    homePageTitle: string;
    homeDescription : string;
    homeList1 : string;
    homeList2 : string;
    homeList3 : string;

    constructor(private titleService: TitleService, private route: ActivatedRoute, private translationService: TranslationService) {
        
    }

    ngOnInit() {
        this.titleService.setTitle(this.route.snapshot.data['title']); this.initTranslations();
    }

    initTranslations() {
        this.translationService.translate('home.pageTitle', 'Identity Service Front Office', (data) => this.homePageTitle = data);
        this.translationService.translate('home.description', 'Identity Service Front Office provides user interface for', (data) => this.homeDescription = data);
        this.translationService.translate('home.List1', 'Creating signed certificates', (data) => this.homeList1 = data);
        this.translationService.translate('home.List2', 'Sign certificate sign requests', (data) => this.homeList2 = data);
        this.translationService.translate('home.List3', 'More to come..', (data) => this.homeList3 = data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/homeView.component.ts